import { InfoItem } from "@/components/info-item";
import { useAppSelector } from "@/app/appStore";
import { selectSelectedEvent } from "@/entities/annotation";
import { displayUUID, formatAbsoluteCoordinates } from "@/shared";
import { formatTimestamp } from "../../lib/helpers";
import { ANNOTATION_TYPES } from "@/entities/annotation/model/consts";

const JourneyEventDetails = () => {
  const selectedEvent = useAppSelector(selectSelectedEvent);

  if (!selectedEvent || selectedEvent.type !== ANNOTATION_TYPES.JOURNEY) {
    return null;
  }

  const pinCoordinates = formatAbsoluteCoordinates(
    selectedEvent?.pinCoordinates.relativeX,
    selectedEvent?.pinCoordinates.relativeY,
    selectedEvent.cameraImageWidth,
    selectedEvent.cameraImageHeight
  );

  return (
    <>
      <InfoItem label="Event type" value={selectedEvent?.eventType} />
      <InfoItem
        label="Zone"
        value={selectedEvent.zone?.description || "-"}
        copyValue={selectedEvent.zone?.id || "-"}
      />
      <InfoItem
        label="Journey ID"
        value={
          selectedEvent.journeyId
            ? displayUUID(selectedEvent.journeyId)
            : undefined
        }
        copyValue={selectedEvent.journeyId || undefined}
      />
      <InfoItem
        label="Order ID"
        value={displayUUID(selectedEvent.orderId)}
        copyValue={selectedEvent.orderId}
      />
      <InfoItem
        label="Timestamp"
        value={formatTimestamp(selectedEvent.timestamp)}
        copyValue={selectedEvent.timestamp.toISOString()}
      />
      <InfoItem label="Pin coordinates (x,y)" value={pinCoordinates} />
      <InfoItem
        label="Camera image dimensions"
        value={`${selectedEvent?.cameraImageWidth}x${selectedEvent?.cameraImageHeight}`}
      />
      <InfoItem label="Annotated camera" value={selectedEvent?.cameraId} />
      <InfoItem label="Note" value={selectedEvent.notes || "-"} />
    </>
  );
};

export default JourneyEventDetails;
